<template>
  <div class="content__column content__column--small" v-if="image">
    <h1 class="content__title">Editar Imagen de Galería</h1>
    <form class="form" @submit.prevent="saveGallery">
      <div class="fom__fieldset">
         <div class="form__container">
          <div class="form__image form__image--wide">
            <label class="form__label" for="status_id">Imagen</label>
            <img :src="cover" alt="Gallery Image" class="form__thumb">
            <button class="btn btn__action btn--small" @click.prevent="showMedia = true">Cargar Imagen</button>
            <button v-if="image.image" class="btn btn__transparent btn--small" @click.prevent="cover = null">Quitar Imagen</button>
          </div>
        </div>
        <div class="form__container">
          <label for="name" class="form__label form__label--required">Nombre de la Imagen</label>
          <input type="text" class="form__input" name="name" id="name" v-model="image.name" v-validate="validation.name">
          <span v-show="errors.has('name')" class="form__alert" v-text="errors.first('name')"></span>
        </div>
        <div class="form__container">
          <label for="title" class="form__label">Título de la Imagen</label>
          <input type="text" class="form__input" name="title" id="title" v-model="image.title" v-validate="validation.title">
          <span v-show="errors.has('title')" class="form__alert" v-text="errors.first('title')"></span>
        </div>
        <div class="form__container">
          <label for="description" class="form__label">Descripción de la Imagen</label>
          <textarea type="text" class="form__input form__input--textarea" name="description" id="description" v-model="image.description" v-validate="validation.description"></textarea>
          <span v-show="errors.has('description')" class="form__alert" v-text="errors.first('description')"></span>
        </div>
        <div class="form__container">
          <label for="url" class="form__label">Enlace Principal de la imagen</label>
          <input type="url" class="form__input" name="url" id="url" v-model="image.url" v-validate="validation.url">
          <span v-show="errors.has('url')" class="form__alert" v-text="errors.first('url')"></span>
        </div>
        <div class="form__container">
          <label for="link1_text" class="form__label">Texto de enlace 1</label>
          <input type="text" class="form__input" name="link1_text" id="link1_text" v-model="link1.text" v-validate="validation.link1_text">
          <span v-show="errors.has('link1_text')" class="form__alert" v-text="errors.first('link1_text')"></span>
        </div>
        <div class="form__container">
          <label for="link1_url" class="form__label">Enlace 1</label>
          <input type="url" class="form__input" name="link1_url" id="link1_url" v-model="link1.url" v-validate="validation.link1_url">
          <span v-show="errors.has('link1_url')" class="form__alert" v-text="errors.first('link1_url')"></span>
        </div>
        <div class="form__container">
          <label for="link2_text" class="form__label">Texto de enlace 2</label>
          <input type="text" class="form__input" name="link2_text" id="link2_text" v-model="link2.text" v-validate="validation.link2_text">
          <span v-show="errors.has('link2_text')" class="form__alert" v-text="errors.first('link2_text')"></span>
        </div>
        <div class="form__container">
          <label for="link2_url" class="form__label">Enlace 2</label>
          <input type="url" class="form__input" name="link2_url" id="link2_url" v-model="link2.url" v-validate="validation.link2_url">
          <span v-show="errors.has('link2_url')" class="form__alert" v-text="errors.first('link2_url')"></span>
        </div>
        <div class="form__container">
          <label class="form__label form__label--required" for="status_id"> Estatus de la Imagen</label>
          <div class="form__select-container">
            <select name="status_id" id="status_id" class="form__select" v-validate="validation.status_id" v-model="image.status_id">
              <option hidden :value="null">Elija un estatus</option>
              <option v-for="(status, index) in images_status" :key="index" :value="status.id" v-text="status.name"></option>
            </select>
          </div>
          <span v-show="errors.has('status_id')" class="form__alert" v-text="errors.first('status_id')"></span>
        </div>
        <div class="form__container">
          <label class="form__label form__label--required" for="gallery_id">Galerías</label>
          <div class="form__select-container">
            <select name="gallery_id" id="gallery_id" class="form__select" v-validate="validation.gallery_id" v-model="image.gallery_id">
              <option :value="null">Seleccione una Galería</option>
              <option v-for="(gallery, index) in galleries" :key="index" :value="gallery.id" v-text="gallery.name"></option>
            </select>
          </div>
          <span v-show="errors.has('gallery_id')" class="form__alert" v-text="errors.first('gallery_id')"></span>
        </div>
      </div>
      <input type="submit" class="btn btn__action btn--regular" value="Guardar">
      <button @click.prevent="$emit('new')" class="btn btn__transparent btn--regular">Agregar Nueva Imagen</button>
    </form>
    <media-popup @close="showMedia = false" v-if="showMedia" field="cover"></media-popup>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import {images_status} from './mocks'
import mediaPopup from '@/components/media/popup'
import {config} from '@/core/config/base'
import Mixins from './mixins'
export default {
  props: {
    image: {
      type: Object,
      required: false,
      default: function () {
        return {
          id: null,
          name: null,
          title: null,
          description: null,
          status_id: null,
          gallery_id: null,
          image: null,
          url: null,
          url_type: null,
          link1: null,
          link2: null,
          sort: 1
        }
      }
    }
  },
  mixins: [
    httpService,
    Mixins
  ],
  components: {
    mediaPopup
  },
  data: function () {
    return {
      newImage: false,
      showMedia: false,
      galleries: null,
      images_status: images_status,
      validation: {
        name: 'required|max:50',
        title: 'max:255',
        status_id: 'required|min_value:1|max:4',
        gallery_id: 'min_value:1|max:11',
        url: 'url',
        link1_url: 'url',
        link2_url: 'url'
      }
    }
  },
  created: function () {
    this.getGalleries()
  },
  mounted: function () {
    this.$on('cover', media => {
      this.cover = media.image
    })
  },
  methods: {
    saveGallery: function () {
      this.image.link1 = JSON.stringify(this.link1)
      this.image.link2 = JSON.stringify(this.link2)
      this.$validator.validateAll()
        .then(
          result => {
            if (result) {
              let httpRequest = {
                params: '',
                module: 'gallery_images',
                element: this.image
              }
              let action
              if (this.image.id) {
                action = this.put(this.image.id, httpRequest)
              } else {
                action = this.post(httpRequest)
              }
              action.then(
                response => {
                  if (!this.image.id) {
                    this.image.id = response.data.current_id
                  }
                  this.$store.commit('elementChanged', {
                    module: 'galleryImageEdit',
                    time: Math.round((new Date()).getTime() / 1000)
                  })
                  this.$store.commit('notificate', {
                    title: 'IMAGEN GUARDADA',
                    text: 'La imagen de galería ha sido guardada correctamente',
                    type: 'success'
                  })
                }
              ).catch(
                () => {
                  this.$store.commit('notificate', {
                    title: 'IMAGEN NO GUARDADA',
                    text: 'La imagen de la galería no ha sido guardada, por favor, intente más tarde',
                    type: 'error'
                  })
                }
              )
            }
          }
        )
    },
    getGalleries: function () {
      let httpRequest = {
        params: '',
        module: 'galleries'
      }
      this.get(httpRequest)
        .then(
          galleries => {
            this.galleries = galleries.data
          }
        ).catch(
          () => {
            this.galleries = null
          }
        )
    }
  },
  computed: {
    cover: {
      get: function () {
        if (this.image.image) {
          let image = undefined
          if (this.newImage) {
            image = this.image.image
          } else {
            image = JSON.parse(this.image.image)
          }
          return config.statics.url + image.sizes.small
        } else {
         return config.statics.dummy
        }
      }, set: function (value) {
        this.newImage = true
        this.image.image = value
      }
    },
    link1: function () {
      return !this.image.link1 ? {} : JSON.parse(this.image.link1)
    },
    link2: function () {
      return !this.image.link2 ? {} : JSON.parse(this.image.link2)
    }
  }
}
</script>

<style lang="sass">
  @import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/gallery_images/edit.vue